import React from "react";
import { MdWeb } from "react-icons/md";
import { SiAdobexd } from "react-icons/si";
import { BiServer } from "react-icons/bi";
import { VscServerProcess } from "react-icons/vsc";
const Services = () => {
  return (
    <div className=" dark:text-[#E0E2DB] mt-2 grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* cards */}
      <div className=" cursor-not-allowed border shadow-lg p-5 rounded-xl hover:scale-105  justify-center">
        {/* icon */}
        <div className="flex justify-center text-[#62389c] text-4xl py-2">
          <SiAdobexd />
        </div>
        {/* service */}
        <h1 className=" text-center font-bold text-2xl py-2">UI/UX Design</h1>
        {/* description */}
        <p className=" text-justify">
          Crafting visually appealing and intuitive user interfaces (UI) using
          tools like Adobe XD. Focusing on enhancing user experience (UX) to
          create engaging web applications that captivate users
        </p>
      </div>
      <a
        href="#frontend"
        className="border shadow-lg p-5 rounded-xl hover:scale-105 cursor-pointer justify-center"
      >
        {/* icon */}
        <div className="flex justify-center text-[#38599c] text-4xl py-2">
          <MdWeb />
        </div>
        {/* service */}
        <h1 className=" text-center font-bold text-2xl py-2">
          Frontend Web Development
        </h1>
        {/* description */}
        <p className=" text-justify">
          Creating captivating web interfaces using React,tailwind CSS, and
          JavaScript. Transforming designs into functional, visually appealing
          UI to ensure an exceptional UX.
        </p>
      </a>
      <a
        href="#backend"
        className="border shadow-lg p-5 rounded-xl hover:scale-105 cursor-pointer justify-center"
      >
        {/* icon */}
        <div className="flex justify-center text-[#389c67] text-4xl py-2">
          <BiServer />
        </div>
        {/* service */}
        <h1 className=" text-center font-bold text-2xl py-2">
          Backend Web Development
        </h1>
        {/* description */}
        <p className="text-center text-justify">
          Building a robust server-side architecture, managing databases,
          implementing user authentication, and application logic. Utilizing
          technologies such as Node.js, Express and Sequelize to develop
          scalable, secure, and efficient backend systems.
        </p>
      </a>
      <div className="border shadow-lg p-5 rounded-xl hover:scale-105 cursor-pointer justify-center">
        {/* icon */}
        <div className="flex justify-center text-[#8f9c38] text-4xl py-2">
          <VscServerProcess />
        </div>
        {/* service */}
        <h1 className=" text-center font-bold text-2xl py-2">
          Full-Stack Web Development
        </h1>
        {/* description */}
        <p className="text-justify">
          Seamlessly integrating both frontend and backend development to
          deliver complete, functional web applications. Proficient in UI/UX
          design, frontend technologies, and backend architecture, ensuring a
          fluid user experience.
        </p>
      </div>
    </div>
  );
};

export default Services;
